import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { gridDisplay } from "../general-displays/grid-display";

export function spinRecordDisplay(record: SpinRecord) {

    const containerElement = document.createElement("div");

    if (record.grid){
        const gridElement = gridDisplay(record);
        containerElement.appendChild(gridElement);
        containerElement.style.width = "100%";
        containerElement.style.height = "90%";
    }

    const dataElement = document.createElement("div");
    dataElement.innerHTML += "";

    containerElement.appendChild(dataElement);

    return containerElement;
}
